module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassic-Bold_web-f840a00c4dd333195dd0131672cee19a.woff2";